import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { setCurrentItem, getProduct } from '../stockActions';

const filterCaseInsensitive = (filter, row) => {
  const id = filter.pivotId || filter.id;
  return row[id] !== undefined
    ? String(row[id].toString().toLowerCase()).includes(
        filter.value.toLowerCase()
      )
    : true;
};

const StockTable = ({
  companyStock,
  loading,
  dispatchCurrentItem,
  dispatchGetProduct
}) => {
  const getTrProps = (state, rowInfo) => {
    if (rowInfo) {
      return {
        onClick: () => {
          dispatchCurrentItem(rowInfo.original);
          dispatchGetProduct(rowInfo.original.id);
        }
      };
    }
    return {};
  };
  return (
    <div>
      <ReactTable
        data={companyStock}
        loading={loading}
        noDataText="Pas de résultats"
        nextText="Suivant"
        loadingText="Mise à jour du stock en cours ..."
        previousText="Précédent"
        defaultPageSize={10}
        rowsText="lignes"
        filterable
        style={{ width: '100%', cursor: 'pointer' }}
        defaultFilterMethod={filterCaseInsensitive}
        getTrProps={getTrProps}
        columns={[
          {
            Header: 'État actuel de votre stock',
            columns: [
              {
                Header: (
                  <span style={{ fontWeight: 'bold' }}> Description </span>
                ),
                accessor: 'name',
                minWidth: 300
              },
              {
                Header: <span style={{ fontWeight: 'bold' }}> Taille </span>,
                accessor: 'size',
                minWidth: 70
              },
              {
                Header: <span style={{ fontWeight: 'bold' }}> Couleur </span>,
                accessor: 'color',
                minWidth: 100
              },
              {
                Header: (
                  <span style={{ fontWeight: 'bold' }}> Code à barres </span>
                ),
                accessor: 'barcodeValue',
                minWidth: 170
              },
              {
                Header: <span style={{ fontWeight: 'bold' }}> Référence </span>,
                accessor: 'reference',
                minWidth: 130
              },
              {
                Header: (
                  <span style={{ fontWeight: 'bold' }}>Quantité physique</span>
                ),
                accessor: 'quantity',
                minWidth: 120
              },
              {
                Header: (
                  <span style={{ fontWeight: 'bold' }}>
                    {' '}
                    Quantité prévisionnelle{' '}
                  </span>
                ),
                accessor: 'forecastQuantity',
                minWidth: 150
              },
              {
                Header: <span style={{ fontWeight: 'bold' }}> Buffer </span>,
                accessor: 'bufferQuantity',
                minWidth: 100
              },
              {
                Header: (
                  <span style={{ fontWeight: 'bold' }}> Défectueux </span>
                ),
                accessor: 'defectiveQuantity',
                minWidth: 100
              }
            ]
          }
        ]}
        defaultSorted={[
          {
            id: 'age',
            desc: true
          }
        ]}
        className="-striped -highlight"
      />
    </div>
  );
};

const mapStateToProps = state => ({
  companyStock: state.stock.companyStock,
  loading: state.stock.loading
});

const mapDispatchToProps = dispatch => ({
  dispatchCurrentItem: item => dispatch(setCurrentItem(item)),
  dispatchGetProduct: id => dispatch(getProduct(id))
});

StockTable.propTypes = {
  companyStock: PropTypes.array,
  loading: PropTypes.bool.isRequired,
  dispatchCurrentItem: PropTypes.func,
  dispatchGetProduct: PropTypes.func
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StockTable);
